import type { IAppStatus } from 'BreetHelpers';

import type { IStatusIcon } from './helpers';

export const StatusIcon = ({ status = 'successful', ...rest }: IStatusIcon) => {
	const isComponentStatus = (statusArg: IAppStatus) => typeof status !== 'boolean' && status === statusArg;
	const isBooleanStatus = (statusArg: IAppStatus) => typeof status === 'boolean' && status === statusArg;

	if (isComponentStatus('successful'))
		return (
			<svg
				width='85'
				height='24'
				viewBox='0 0 85 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-successful'
				data-testid='status-icon'
			>
				<rect
					x='0.25'
					y='0.25'
					width='84.5'
					height='23.5'
					rx='11.75'
					fill='#E9FBF1'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='84.5'
					height='23.5'
					rx='11.75'
					stroke='#A3EFC3'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#17B26A'
				/>
				<path
					d='M22.255 6.696C23.863 6.696 25.255 7.404 25.459 9.084H24.511C24.331 8.112 23.647 7.512 22.315 7.512C21.115 7.512 20.335 8.052 20.335 8.976C20.335 9.696 20.851 10.104 21.823 10.296L23.155 10.548C24.619 10.836 25.447 11.496 25.447 12.696C25.447 14.184 24.223 15.144 22.387 15.144C20.431 15.144 19.159 14.148 18.979 12.384H19.915C20.107 13.608 20.983 14.292 22.435 14.292C23.683 14.292 24.475 13.728 24.475 12.804C24.475 12.156 24.031 11.652 22.999 11.472L21.475 11.172C20.023 10.896 19.327 10.152 19.327 9.036C19.327 7.608 20.503 6.696 22.255 6.696ZM30.7672 9.432H31.6792V15H30.7672V14.364C30.2512 14.856 29.5672 15.144 28.7752 15.144C27.3592 15.144 26.3872 14.172 26.3872 12.6V9.432H27.2992V12.552C27.2992 13.68 27.9592 14.304 28.9432 14.304C29.6032 14.304 30.2872 13.956 30.7672 13.32V9.432ZM35.7944 14.304C36.6584 14.304 37.3064 13.836 37.4744 13.104H38.4224C38.2064 14.316 37.1384 15.144 35.7944 15.144C34.1024 15.144 32.8784 13.86 32.8784 12.216C32.8784 10.572 34.1024 9.288 35.7944 9.288C37.1384 9.288 38.2064 10.116 38.4224 11.34H37.4744C37.3064 10.608 36.6584 10.128 35.7944 10.128C34.5824 10.128 33.7904 11.064 33.7904 12.216C33.7904 13.38 34.5824 14.304 35.7944 14.304ZM42.2402 14.304C43.1042 14.304 43.7522 13.836 43.9202 13.104H44.8682C44.6522 14.316 43.5842 15.144 42.2402 15.144C40.5482 15.144 39.3242 13.86 39.3242 12.216C39.3242 10.572 40.5482 9.288 42.2402 9.288C43.5842 9.288 44.6522 10.116 44.8682 11.34H43.9202C43.7522 10.608 43.1042 10.128 42.2402 10.128C41.0282 10.128 40.2362 11.064 40.2362 12.216C40.2362 13.38 41.0282 14.304 42.2402 14.304ZM48.626 9.288C50.414 9.288 51.53 10.668 51.35 12.492H46.694C46.802 13.524 47.51 14.328 48.674 14.328C49.382 14.328 49.922 14.076 50.162 13.608H51.182C50.834 14.568 49.874 15.144 48.674 15.144C46.958 15.144 45.77 13.86 45.77 12.216C45.77 10.572 46.946 9.288 48.626 9.288ZM48.626 10.08C47.522 10.08 46.838 10.86 46.706 11.844H50.438C50.39 10.74 49.682 10.08 48.626 10.08ZM52.9249 13.248C53.0929 13.992 53.6689 14.388 54.6889 14.388C55.5529 14.388 56.1409 14.064 56.1409 13.5C56.1409 13.032 55.7689 12.756 55.2289 12.66L53.9689 12.456C53.0569 12.3 52.3129 11.892 52.3129 10.944C52.3129 9.912 53.2249 9.288 54.5689 9.288C55.7329 9.288 56.8849 9.732 56.9929 11.052H56.1409C56.0449 10.356 55.4569 10.032 54.5689 10.032C53.7289 10.032 53.2249 10.356 53.2249 10.86C53.2249 11.268 53.5009 11.568 54.2569 11.7L55.3609 11.88C56.1649 12.012 57.0169 12.372 57.0169 13.44C57.0169 14.532 56.0329 15.144 54.6649 15.144C53.2489 15.144 52.2409 14.556 52.0729 13.248H52.9249ZM58.5386 13.248C58.7066 13.992 59.2826 14.388 60.3026 14.388C61.1666 14.388 61.7546 14.064 61.7546 13.5C61.7546 13.032 61.3826 12.756 60.8426 12.66L59.5826 12.456C58.6706 12.3 57.9266 11.892 57.9266 10.944C57.9266 9.912 58.8386 9.288 60.1826 9.288C61.3466 9.288 62.4986 9.732 62.6066 11.052H61.7546C61.6586 10.356 61.0706 10.032 60.1826 10.032C59.3426 10.032 58.8386 10.356 58.8386 10.86C58.8386 11.268 59.1146 11.568 59.8706 11.7L60.9746 11.88C61.7786 12.012 62.6306 12.372 62.6306 13.44C62.6306 14.532 61.6466 15.144 60.2786 15.144C58.8626 15.144 57.8546 14.556 57.6866 13.248H58.5386ZM65.4913 8.436V9.432H67.7233V10.212H65.4913V15H64.5793V10.212H62.9593V9.432H64.5793V8.436C64.5793 7.14 65.4433 6.336 66.6673 6.336C66.9913 6.336 67.3633 6.384 67.7713 6.504L67.6393 7.272C67.3393 7.188 66.9913 7.128 66.7633 7.128C65.9833 7.128 65.4913 7.644 65.4913 8.436ZM72.4306 9.432H73.3426V15H72.4306V14.364C71.9146 14.856 71.2306 15.144 70.4386 15.144C69.0226 15.144 68.0506 14.172 68.0506 12.6V9.432H68.9626V12.552C68.9626 13.68 69.6226 14.304 70.6066 14.304C71.2666 14.304 71.9506 13.956 72.4306 13.32V9.432ZM74.8299 6.48H75.7419V15H74.8299V6.48Z'
					fill='#09541A'
					className='text-path'
				/>
			</svg>
		);

	if (isComponentStatus('reversed'))
		return (
			<svg
				width='75'
				height='24'
				viewBox='0 0 75 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-reversed'
			>
				<rect
					x='0.25'
					y='0.25'
					width='74.5'
					height='23.5'
					rx='11.75'
					fill='#FFF1FF'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='74.5'
					height='23.5'
					rx='11.75'
					stroke='#EECAEE'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#C353A4'
				/>
				<path
					d='M24.6569 15L22.2809 12.084H20.2049V15H19.2569V6.84H22.3409C24.1769 6.84 25.4609 7.848 25.4609 9.456C25.4609 10.752 24.6329 11.664 23.3609 11.964L25.8329 15H24.6569ZM20.2049 7.716V11.208H22.3169C23.5889 11.208 24.5249 10.548 24.5249 9.456C24.5249 8.364 23.5889 7.716 22.3169 7.716H20.2049ZM28.8418 9.288C30.6298 9.288 31.7458 10.668 31.5658 12.492H26.9098C27.0178 13.524 27.7258 14.328 28.8898 14.328C29.5978 14.328 30.1378 14.076 30.3778 13.608H31.3978C31.0498 14.568 30.0898 15.144 28.8898 15.144C27.1738 15.144 25.9858 13.86 25.9858 12.216C25.9858 10.572 27.1618 9.288 28.8418 9.288ZM28.8418 10.08C27.7378 10.08 27.0538 10.86 26.9218 11.844H30.6538C30.6058 10.74 29.8978 10.08 28.8418 10.08ZM36.8455 9.432H37.8175L35.1895 15H34.3495L31.7215 9.432H32.6935L34.7695 13.848L36.8455 9.432ZM40.7725 9.288C42.5605 9.288 43.6765 10.668 43.4965 12.492H38.8405C38.9485 13.524 39.6565 14.328 40.8205 14.328C41.5285 14.328 42.0685 14.076 42.3085 13.608H43.3285C42.9805 14.568 42.0205 15.144 40.8205 15.144C39.1045 15.144 37.9165 13.86 37.9165 12.216C37.9165 10.572 39.0925 9.288 40.7725 9.288ZM40.7725 10.08C39.6685 10.08 38.9845 10.86 38.8525 11.844H42.5845C42.5365 10.74 41.8285 10.08 40.7725 10.08ZM45.5154 10.344C46.0314 9.684 46.7754 9.3 47.6634 9.3V10.164C46.7514 10.188 46.0074 10.608 45.5154 11.376V15H44.6034V9.432H45.5154V10.344ZM48.7281 13.248C48.8961 13.992 49.4721 14.388 50.4921 14.388C51.3561 14.388 51.9441 14.064 51.9441 13.5C51.9441 13.032 51.5721 12.756 51.0321 12.66L49.7721 12.456C48.8601 12.3 48.1161 11.892 48.1161 10.944C48.1161 9.912 49.0281 9.288 50.3721 9.288C51.5361 9.288 52.6881 9.732 52.7961 11.052H51.9441C51.8481 10.356 51.2601 10.032 50.3721 10.032C49.5321 10.032 49.0281 10.356 49.0281 10.86C49.0281 11.268 49.3041 11.568 50.0601 11.7L51.1641 11.88C51.9681 12.012 52.8201 12.372 52.8201 13.44C52.8201 14.532 51.8361 15.144 50.4681 15.144C49.0521 15.144 48.0441 14.556 47.8761 13.248H48.7281ZM56.477 9.288C58.265 9.288 59.381 10.668 59.201 12.492H54.545C54.653 13.524 55.361 14.328 56.525 14.328C57.233 14.328 57.773 14.076 58.013 13.608H59.033C58.685 14.568 57.725 15.144 56.525 15.144C54.809 15.144 53.621 13.86 53.621 12.216C53.621 10.572 54.797 9.288 56.477 9.288ZM56.477 10.08C55.373 10.08 54.689 10.86 54.557 11.844H58.289C58.241 10.74 57.533 10.08 56.477 10.08ZM64.9611 6.48H65.8731V15H64.9611V14.424C64.4691 14.88 63.7971 15.144 63.0051 15.144C61.4091 15.144 60.1371 13.836 60.1371 12.216C60.1371 10.584 61.4091 9.288 63.0051 9.288C63.7971 9.288 64.4691 9.552 64.9611 10.008V6.48ZM63.1251 14.304C63.8571 14.304 64.5051 14.028 64.9611 13.356V11.076C64.5051 10.404 63.8571 10.128 63.1251 10.128C61.9491 10.128 61.0491 11.064 61.0491 12.216C61.0491 13.368 61.9491 14.304 63.1251 14.304Z'
					fill='#970F71'
					className='text-path'
				/>
			</svg>
		);

	if (isComponentStatus('pending'))
		return (
			<svg
				width='70'
				height='24'
				viewBox='0 0 70 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-pending'
			>
				<rect
					x='0.25'
					y='0.25'
					width='69.5'
					height='23.5'
					rx='11.75'
					fill='#FEF5E7'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='69.5'
					height='23.5'
					rx='11.75'
					stroke='#FBD99C'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#F59E0C'
				/>
				<path
					d='M22.4204 6.84C24.3044 6.84 25.5644 7.92 25.5644 9.552C25.5644 11.244 24.2564 12.36 22.3004 12.36H20.4884V15H19.5404V6.84H22.4204ZM22.3844 11.484C23.7284 11.484 24.6284 10.716 24.6284 9.552C24.6284 8.448 23.7284 7.704 22.3844 7.704H20.4884V11.484H22.3844ZM28.6448 9.288C30.4328 9.288 31.5488 10.668 31.3688 12.492H26.7128C26.8208 13.524 27.5288 14.328 28.6928 14.328C29.4008 14.328 29.9408 14.076 30.1808 13.608H31.2008C30.8528 14.568 29.8928 15.144 28.6928 15.144C26.9768 15.144 25.7888 13.86 25.7888 12.216C25.7888 10.572 26.9648 9.288 28.6448 9.288ZM28.6448 10.08C27.5408 10.08 26.8568 10.86 26.7248 11.844H30.4568C30.4088 10.74 29.7008 10.08 28.6448 10.08ZM35.3797 9.288C36.7957 9.288 37.7677 10.236 37.7677 11.808V15H36.8557V11.856C36.8557 10.728 36.1957 10.128 35.2117 10.128C34.5517 10.128 33.8677 10.464 33.3877 11.088V15H32.4757V9.432H33.3877V10.056C33.9037 9.564 34.5877 9.288 35.3797 9.288ZM43.563 6.48H44.475V15H43.563V14.424C43.071 14.88 42.399 15.144 41.607 15.144C40.011 15.144 38.739 13.836 38.739 12.216C38.739 10.584 40.011 9.288 41.607 9.288C42.399 9.288 43.071 9.552 43.563 10.008V6.48ZM41.727 14.304C42.459 14.304 43.107 14.028 43.563 13.356V11.076C43.107 10.404 42.459 10.128 41.727 10.128C40.551 10.128 39.651 11.064 39.651 12.216C39.651 13.368 40.551 14.304 41.727 14.304ZM46.5769 7.944C46.2289 7.944 45.9649 7.68 45.9649 7.344C45.9649 6.996 46.2289 6.732 46.5769 6.732C46.9249 6.732 47.2009 6.996 47.2009 7.344C47.2009 7.68 46.9249 7.944 46.5769 7.944ZM46.1329 9.432H47.0449V15H46.1329V9.432ZM51.5764 9.288C52.9924 9.288 53.9644 10.236 53.9644 11.808V15H53.0524V11.856C53.0524 10.728 52.3924 10.128 51.4084 10.128C50.7484 10.128 50.0644 10.464 49.5844 11.088V15H48.6724V9.432H49.5844V10.056C50.1004 9.564 50.7844 9.288 51.5764 9.288ZM59.6777 9.432H60.5897V15.276C60.5897 16.908 59.4737 17.904 57.8177 17.904C56.2817 17.904 55.1777 17.04 54.9857 15.804H55.9217C56.0777 16.56 56.7737 17.076 57.8177 17.076C58.9337 17.076 59.6777 16.404 59.6777 15.276V14.232C59.1617 14.688 58.4657 14.952 57.6617 14.952C56.0657 14.952 54.8537 13.68 54.8537 12.144C54.8537 10.5 56.0657 9.288 57.6617 9.288C58.4657 9.288 59.1617 9.552 59.6777 10.008V9.432ZM57.7817 14.148C58.5137 14.148 59.2097 13.848 59.6777 13.164V11.076C59.2097 10.392 58.5137 10.092 57.7817 10.092C56.6057 10.092 55.7657 10.968 55.7657 12.144C55.7657 13.212 56.6057 14.148 57.7817 14.148Z'
					fill='#CF870D'
					className='text-path'
				/>
			</svg>
		);

	if (isComponentStatus('flagged'))
		return (
			<svg
				width='70'
				height='24'
				viewBox='0 0 70 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-error'
			>
				<rect
					x='0.25'
					y='0.25'
					width='69.5'
					height='23.5'
					rx='11.75'
					fill='#F9D7D7'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='69.5'
					height='23.5'
					rx='11.75'
					stroke='#EC8889'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#C11F1E'
				/>
				<path
					d='M24.91 7.716H20.254V10.716H24.406V11.592H20.254V15H19.306V6.84H24.91V7.716ZM25.8424 6.48H26.7544V15H25.8424V6.48ZM32.7344 9.432H33.6464V15H32.7344V14.424C32.2424 14.88 31.5704 15.144 30.7784 15.144C29.1824 15.144 27.9104 13.848 27.9104 12.216C27.9104 10.596 29.1824 9.288 30.7784 9.288C31.5704 9.288 32.2424 9.552 32.7344 10.008V9.432ZM30.8984 14.304C31.6304 14.304 32.2784 14.028 32.7344 13.356V11.076C32.2784 10.404 31.6304 10.128 30.8984 10.128C29.7224 10.128 28.8224 11.064 28.8224 12.216C28.8224 13.368 29.7224 14.304 30.8984 14.304ZM39.6723 9.432H40.5843V15.276C40.5843 16.908 39.4683 17.904 37.8123 17.904C36.2763 17.904 35.1723 17.04 34.9803 15.804H35.9163C36.0723 16.56 36.7683 17.076 37.8123 17.076C38.9283 17.076 39.6723 16.404 39.6723 15.276V14.232C39.1563 14.688 38.4603 14.952 37.6563 14.952C36.0603 14.952 34.8483 13.68 34.8483 12.144C34.8483 10.5 36.0603 9.288 37.6563 9.288C38.4603 9.288 39.1563 9.552 39.6723 10.008V9.432ZM37.7763 14.148C38.5083 14.148 39.2043 13.848 39.6723 13.164V11.076C39.2043 10.392 38.5083 10.092 37.7763 10.092C36.6003 10.092 35.7603 10.968 35.7603 12.144C35.7603 13.212 36.6003 14.148 37.7763 14.148ZM46.6103 9.432H47.5223V15.276C47.5223 16.908 46.4063 17.904 44.7503 17.904C43.2143 17.904 42.1103 17.04 41.9183 15.804H42.8543C43.0103 16.56 43.7063 17.076 44.7503 17.076C45.8663 17.076 46.6103 16.404 46.6103 15.276V14.232C46.0943 14.688 45.3983 14.952 44.5943 14.952C42.9983 14.952 41.7863 13.68 41.7863 12.144C41.7863 10.5 42.9983 9.288 44.5943 9.288C45.3983 9.288 46.0943 9.552 46.6103 10.008V9.432ZM44.7143 14.148C45.4463 14.148 46.1423 13.848 46.6103 13.164V11.076C46.1423 10.392 45.4463 10.092 44.7143 10.092C43.5383 10.092 42.6983 10.968 42.6983 12.144C42.6983 13.212 43.5383 14.148 44.7143 14.148ZM51.4279 9.288C53.2159 9.288 54.3319 10.668 54.1519 12.492H49.4959C49.6039 13.524 50.3119 14.328 51.4759 14.328C52.1839 14.328 52.7239 14.076 52.9639 13.608H53.9839C53.6359 14.568 52.6759 15.144 51.4759 15.144C49.7599 15.144 48.5719 13.86 48.5719 12.216C48.5719 10.572 49.7479 9.288 51.4279 9.288ZM51.4279 10.08C50.3239 10.08 49.6399 10.86 49.5079 11.844H53.2399C53.1919 10.74 52.4839 10.08 51.4279 10.08ZM59.912 6.48H60.824V15H59.912V14.424C59.42 14.88 58.748 15.144 57.956 15.144C56.36 15.144 55.088 13.836 55.088 12.216C55.088 10.584 56.36 9.288 57.956 9.288C58.748 9.288 59.42 9.552 59.912 10.008V6.48ZM58.076 14.304C58.808 14.304 59.456 14.028 59.912 13.356V11.076C59.456 10.404 58.808 10.128 58.076 10.128C56.9 10.128 56 11.064 56 12.216C56 13.368 56.9 14.304 58.076 14.304Z'
					fill='#C11F1E'
					className='text-path'
				/>
			</svg>
		);

	if (isComponentStatus('unsuccessful'))
		return (
			<svg
				width='59'
				height='24'
				viewBox='0 0 59 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-error'
			>
				<rect
					x='0.25'
					y='0.25'
					width='58.5'
					height='23.5'
					rx='11.75'
					fill='#F9D7D7'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='58.5'
					height='23.5'
					rx='11.75'
					stroke='#EC8889'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#C11F1E'
				/>
				<path
					d='M25.1876 7.716H20.5316V10.716H24.6836V11.592H20.5316V15H19.5836V6.84H25.1876V7.716ZM30.117 9.432H31.029V15H30.117V14.424C29.625 14.88 28.953 15.144 28.161 15.144C26.565 15.144 25.293 13.848 25.293 12.216C25.293 10.596 26.565 9.288 28.161 9.288C28.953 9.288 29.625 9.552 30.117 10.008V9.432ZM28.281 14.304C29.013 14.304 29.661 14.028 30.117 13.356V11.076C29.661 10.404 29.013 10.128 28.281 10.128C27.105 10.128 26.205 11.064 26.205 12.216C26.205 13.368 27.105 14.304 28.281 14.304ZM33.1309 7.944C32.7829 7.944 32.5189 7.68 32.5189 7.344C32.5189 6.996 32.7829 6.732 33.1309 6.732C33.4789 6.732 33.7549 6.996 33.7549 7.344C33.7549 7.68 33.4789 7.944 33.1309 7.944ZM32.6869 9.432H33.5989V15H32.6869V9.432ZM35.2264 6.48H36.1384V15H35.2264V6.48ZM40.1504 9.288C41.9384 9.288 43.0544 10.668 42.8744 12.492H38.2184C38.3264 13.524 39.0344 14.328 40.1984 14.328C40.9064 14.328 41.4464 14.076 41.6864 13.608H42.7064C42.3584 14.568 41.3984 15.144 40.1984 15.144C38.4824 15.144 37.2944 13.86 37.2944 12.216C37.2944 10.572 38.4704 9.288 40.1504 9.288ZM40.1504 10.08C39.0464 10.08 38.3624 10.86 38.2304 11.844H41.9624C41.9144 10.74 41.2064 10.08 40.1504 10.08ZM48.6345 6.48H49.5465V15H48.6345V14.424C48.1425 14.88 47.4705 15.144 46.6785 15.144C45.0825 15.144 43.8105 13.836 43.8105 12.216C43.8105 10.584 45.0825 9.288 46.6785 9.288C47.4705 9.288 48.1425 9.552 48.6345 10.008V6.48ZM46.7985 14.304C47.5305 14.304 48.1785 14.028 48.6345 13.356V11.076C48.1785 10.404 47.5305 10.128 46.7985 10.128C45.6225 10.128 44.7225 11.064 44.7225 12.216C44.7225 13.368 45.6225 14.304 46.7985 14.304Z'
					fill='#DF3939'
					className='text-path'
				/>
			</svg>
		);

	if (isComponentStatus('processing'))
		return (
			<svg
				width='79'
				height='24'
				viewBox='0 0 79 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-processing'
			>
				<rect
					x='0.25'
					y='0.25'
					width='78.5'
					height='23.5'
					rx='11.75'
					fill='#CDECF2'
				/>
				<rect
					x='0.25'
					y='0.25'
					width='78.5'
					height='23.5'
					rx='11.75'
					stroke='#82D0DF'
					strokeWidth='0.5'
				/>
				<circle
					cx='10'
					cy='12'
					r='3'
					fill='#036C7F'
				/>
				<path
					d='M22.1738 6.84C24.0578 6.84 25.3178 7.92 25.3178 9.552C25.3178 11.244 24.0098 12.36 22.0538 12.36H20.2418V15H19.2938V6.84H22.1738ZM22.1378 11.484C23.4818 11.484 24.3818 10.716 24.3818 9.552C24.3818 8.448 23.4818 7.704 22.1378 7.704H20.2418V11.484H22.1378ZM27.0469 10.344C27.5629 9.684 28.3069 9.3 29.1949 9.3V10.164C28.2829 10.188 27.5389 10.608 27.0469 11.376V15H26.1349V9.432H27.0469V10.344ZM32.4911 9.288C34.1831 9.288 35.4431 10.536 35.4431 12.216C35.4431 13.896 34.1831 15.144 32.4911 15.144C30.7871 15.144 29.5271 13.896 29.5271 12.216C29.5271 10.536 30.7871 9.288 32.4911 9.288ZM32.4911 14.304C33.6551 14.304 34.5191 13.416 34.5191 12.216C34.5191 11.016 33.6551 10.128 32.4911 10.128C31.3151 10.128 30.4391 11.016 30.4391 12.216C30.4391 13.416 31.3151 14.304 32.4911 14.304ZM39.2639 14.304C40.1279 14.304 40.7759 13.836 40.9439 13.104H41.8919C41.6759 14.316 40.6079 15.144 39.2639 15.144C37.5719 15.144 36.3479 13.86 36.3479 12.216C36.3479 10.572 37.5719 9.288 39.2639 9.288C40.6079 9.288 41.6759 10.116 41.8919 11.34H40.9439C40.7759 10.608 40.1279 10.128 39.2639 10.128C38.0519 10.128 37.2599 11.064 37.2599 12.216C37.2599 13.38 38.0519 14.304 39.2639 14.304ZM45.6497 9.288C47.4377 9.288 48.5537 10.668 48.3737 12.492H43.7177C43.8257 13.524 44.5337 14.328 45.6977 14.328C46.4057 14.328 46.9457 14.076 47.1857 13.608H48.2057C47.8577 14.568 46.8977 15.144 45.6977 15.144C43.9817 15.144 42.7937 13.86 42.7937 12.216C42.7937 10.572 43.9697 9.288 45.6497 9.288ZM45.6497 10.08C44.5457 10.08 43.8617 10.86 43.7297 11.844H47.4617C47.4137 10.74 46.7057 10.08 45.6497 10.08ZM49.9486 13.248C50.1166 13.992 50.6926 14.388 51.7126 14.388C52.5766 14.388 53.1646 14.064 53.1646 13.5C53.1646 13.032 52.7926 12.756 52.2526 12.66L50.9926 12.456C50.0806 12.3 49.3366 11.892 49.3366 10.944C49.3366 9.912 50.2486 9.288 51.5926 9.288C52.7566 9.288 53.9086 9.732 54.0166 11.052H53.1646C53.0686 10.356 52.4806 10.032 51.5926 10.032C50.7526 10.032 50.2486 10.356 50.2486 10.86C50.2486 11.268 50.5246 11.568 51.2806 11.7L52.3846 11.88C53.1886 12.012 54.0406 12.372 54.0406 13.44C54.0406 14.532 53.0566 15.144 51.6886 15.144C50.2726 15.144 49.2646 14.556 49.0966 13.248H49.9486ZM55.8235 7.944C55.4755 7.944 55.2115 7.68 55.2115 7.344C55.2115 6.996 55.4755 6.732 55.8235 6.732C56.1715 6.732 56.4475 6.996 56.4475 7.344C56.4475 7.68 56.1715 7.944 55.8235 7.944ZM55.3795 9.432H56.2915V15H55.3795V9.432ZM60.823 9.288C62.239 9.288 63.211 10.236 63.211 11.808V15H62.299V11.856C62.299 10.728 61.639 10.128 60.655 10.128C59.995 10.128 59.311 10.464 58.831 11.088V15H57.919V9.432H58.831V10.056C59.347 9.564 60.031 9.288 60.823 9.288ZM68.9242 9.432H69.8362V15.276C69.8362 16.908 68.7202 17.904 67.0642 17.904C65.5282 17.904 64.4242 17.04 64.2322 15.804H65.1682C65.3242 16.56 66.0202 17.076 67.0642 17.076C68.1802 17.076 68.9242 16.404 68.9242 15.276V14.232C68.4082 14.688 67.7122 14.952 66.9082 14.952C65.3122 14.952 64.1002 13.68 64.1002 12.144C64.1002 10.5 65.3122 9.288 66.9082 9.288C67.7122 9.288 68.4082 9.552 68.9242 10.008V9.432ZM67.0282 14.148C67.7602 14.148 68.4562 13.848 68.9242 13.164V11.076C68.4562 10.392 67.7602 10.092 67.0282 10.092C65.8522 10.092 65.0122 10.968 65.0122 12.144C65.0122 13.212 65.8522 14.148 67.0282 14.148Z'
					fill='#05A2BF'
					className='text-path'
				/>
			</svg>
		);

	if (isBooleanStatus(true))
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
				className='status-icon-success'
			>
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#21CE6B'
				/>
				<g clipPath='url(#clip0_10830_206823)'>
					<path
						d='M10.6665 14.1145L16.7945 7.98584L17.7378 8.92851L10.6665 15.9998L6.42383 11.7572L7.3665 10.8145L10.6665 14.1145Z'
						fill='white'
					/>
				</g>
				<defs>
					<clipPath id='clip0_10830_206823'>
						<rect
							width='16'
							height='16'
							fill='white'
							transform='translate(4 4)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	if (isBooleanStatus(false))
		return (
			<svg
				width='24'
				height='24'
				viewBox='0 0 24 24'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<rect
					width='24'
					height='24'
					rx='12'
					fill='#DF3939'
				/>
				<g clipPath='url(#clip0_10830_206880)'>
					<path
						d='M12 11.0573L15.3 7.75732L16.2427 8.69999L12.9427 12L16.2427 15.3L15.3 16.2427L12 12.9427L8.69999 16.2427L7.75732 15.3L11.0573 12L7.75732 8.69999L8.69999 7.75732L12 11.0573Z'
						fill='white'
					/>
				</g>
				<defs>
					<clipPath id='clip0_10830_206880'>
						<rect
							width='16'
							height='16'
							fill='white'
							transform='translate(4 4)'
						/>
					</clipPath>
				</defs>
			</svg>
		);

	return <></>;
};
